import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import BASE_URL from '../config/config';

const Inicio = () => {
  const [soporteDisponible, setSoporteDisponible] = useState(false);
  const [horario, setHorario] = useState(null); // objeto: { hora_inicio, hora_cierre, hora_cierre_viernes }

  const token = localStorage.getItem("AuthToken");
  const logged = !!token;
  const navigate = useNavigate();

  const handleCreateTicket = (department) => {
    window.scrollTo(0, 0);
    if (logged) {
      navigate('/nuevo-ticket', { state: { department } });
    } else {
      navigate('/iniciar-sesion');
    }
  };

  // Obtener horario desde ajustes
  useEffect(() => {
    const fetchHorario = async () => {
      try {
        const resp = await axios.get(`${BASE_URL}/ajustes/horario`);
        const valor = resp?.data?.ajuste?.valor;
        if (valor) setHorario(valor);
      } catch {
        setHorario(null);
      }
    };
    fetchHorario();
  }, []);

  // Calcular disponibilidad cuando el horario esté cargado
  useEffect(() => {
    if (!horario) return;

    const ahora = new Date();
    const dia = ahora.getDay();
    const horaDecimal = ahora.getHours() + ahora.getMinutes() / 60;

    const horaInicio = horario.hora_inicio ?? 8;
    const horaCierre = horario.hora_cierre ?? 16;
    const horaCierreViernes = horario.hora_cierre_viernes ?? 15;

    const esLaborable = dia >= 1 && dia <= 5;
    const cierreHoy = dia === 5 ? horaCierreViernes : horaCierre;

    setSoporteDisponible(esLaborable && horaDecimal >= horaInicio && horaDecimal < cierreHoy);
  }, [horario]);

  // Formatear el horario para mostrar en pantalla
  const textoHorario = horario
    ? <>Lunes a Jueves: {horario.hora_inicio}:00–{horario.hora_cierre}:00<br/>Viernes: {horario.hora_inicio}:00–{horario.hora_cierre_viernes}:00</>
    : 'Cargando...';

  return (
    <main className='inicio'>
      <div className="bg-intro">
        <div className='site-width'>
          <div className='intro'>
            <div className="intro-text">
              <h1>El soporte técnico más cercano <br/>para nuestros clientes</h1>
              <p>Haznos saber tu causa. Crea un ticket y sigue el progreso desde esta misma web.</p>
            </div>
            <div className="intro-info">
              <div className="support-time">
                <img src="/images/servicio-al-cliente.svg" alt="Horario de soporte" />
                <div className="support-text">
                  <p>Soporte Técnico</p>
                <p className='disponible'>Activo</p>
                </div>
              </div>
              <div className="office-time">
                <img src="/images/reloj.svg" alt="Horario de oficina" />
                <div className="office-text">
                  <p>Horario de oficina</p>
                  <p>{textoHorario}</p>
                </div>
              </div>
            </div>
          </div>

          {/* departamentos */}
          <div className="departments">
            <div className="department">
              <img src="/images/codigo-cuadrado.svg" alt="Desarrollo" />
              <h2>Dpto. de Desarrollo</h2>
              <p>Si tu cuestión tiene que ver con desarrollo web.</p>
              <button
                className='token-ticket'
                onClick={() => handleCreateTicket('desarrollo')}
              >
                {logged ? 'Crear ticket' : 'Inicia sesión para crear un ticket'}
              </button>
            </div>
            <div className="department">
              <img src="/images/pincel-de-lapiz.svg" alt="Diseño" />
              <h2>Dpto. de Diseño</h2>
              <p>Si tu cuestión tiene que ver con diseño gráfico.</p>
              <button
                className='token-ticket'
                onClick={() => handleCreateTicket('diseno')}
              >
                {logged ? 'Crear ticket' : 'Inicia sesión para crear un ticket'}
              </button>
            </div>
            <div className="department">
              <img src="/images/descubrir.svg" alt="marketing" />
              <h2>Dpto. de Marketing</h2>
              <p>Si tu cuestión tiene que ver con marketing digital.</p>
              <button
                className='token-ticket'
                onClick={() => handleCreateTicket('marketing')}
              >
                {logged ? 'Crear ticket' : 'Inicia sesión para crear un ticket'}
              </button>
              
            </div>
            <div className="department">
              <img src="/images/trofeo.svg" alt="redes sociales" />
              <h2>Dpto. de Redes Sociales</h2>
              <p>Si tu cuestión tiene que ver con redes sociales.</p>
              <button
                className='token-ticket'
                onClick={() => handleCreateTicket('redes_sociales')}
              >
                {logged ? 'Crear ticket' : 'Inicia sesión para crear un ticket'}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* comunidad */}
      <div className='bg-comunidad'>
        <div className="site-width">
          <div className="comunidad">
            <img src="images/imagen-comunidad.svg" alt="Imagen Comunidad" />
            <div className='texto-comunidad'>
              <h2>Juntos construimos <span>comunidad</span></h2>
              <p>Olvida los correos perdidos en la bandeja de entrada y las conversaciones interminables por correo electrónico.</p>
              <p>En nuestro centro de soporte, trabajamos para hacerte la vida más fácil y te ofrecemos la mejor atención al cliente.</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Inicio;
